import { render } from "./TemplateUpload.vue?vue&type=template&id=a749ec0e&scoped=true&lang=html"
import script from "./TemplateUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateUpload.vue?vue&type=script&setup=true&lang=js"

import "./TemplateUpload.vue?vue&type=style&index=0&id=a749ec0e&lang=scss&scoped=true"

import exportComponent from "/home/nootaku/dev/clickado_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a749ec0e"]])

export default __exports__